import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';

export function useRealTime() {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Connect to WebSocket server silently
    const SOCKET_URL = import.meta.env.VITE_WEBSOCKET_URL || '';
    const newSocket = io(SOCKET_URL, {
      withCredentials: true,
      transports: ['websocket', 'polling']
    });

    newSocket.on('connect', () => {
      console.log('⚡ [RealTime] Connected to secure state sync tunnel.');
      setSocket(newSocket);
    });

    // Listen for broadcasts and handle silently (No-Touch Policy)
    newSocket.on('system_announcement', (data) => {
      console.log('📡 [RealTime Broadcast Received]:', data);
      // In a real scenario without No-Touch, we would trigger a toast here.
    });

    newSocket.on('disconnect', () => {
      console.log('⚡ [RealTime] Disconnected from tunnel.');
      setSocket(null);
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);

  return socket;
}
